<template>
    <VanCell center class="in-panel">
        <template #title>
            <div class="flex-row">
                <div class="image">
                    <img :src="goods.coverUrl | resourceUrl" ref="image" @error="handleRefImgError('image')">
                </div>
                <div class="flex-auto mt5px">
                    <div class="fs15px">{{ goods.name }}</div>
                    <div class="flex-row flex-space-between mt5px">
                        <div class="txt-gray">
                            <span class="txt-delete fs12px">￥{{goods.meanPrice.toFixed(2) || 0}}</span>
                        </div>
                        <div class="txt-red">
                            <span>￥{{goods.price.toFixed(2) || 0}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </VanCell>
</template>

<script>
    import RefImgErrorHandler from '../../../mixins/RefImgErrorHandler';
    import Utils from '../../../utils';

    export default {
        name: 'GoodsCard',
        mixins: [RefImgErrorHandler],
        props: {
            goods: {
                type: Object,
                default() {
                    return {};
                },
            },
            coinExchange: {
                type: Number,
                default: 0,
            },
        },
        computed: {
            imageUrl() {
                return Utils.string.splitFirst(this.goods.images);
            },
        },
    };
</script>

<style scoped lang="less">
.image {
    width: 5.6rem;
    height: 4.2rem;
    background-color: #E8E8E8;
    margin-right: 16px;

    img {
        max-width: 100%;
        max-height: 100%;
        display: block;
    }
}
</style>
